module.exports = __webpack_public_path__ + "static/06-46276d05380390ac1bf441cac76b8f54.jpg";